import React, { useState, useRef, useEffect, useMemo, useCallback } from 'react';
import { createPortal } from 'react-dom';
import { ReactComponent as DropDown} from 'img/dropdown.svg';
import styles from  './HistoryDropdown.module.scss';
// import './HistoryDropdown.scss';

export interface Option {
  value: string;
  label: string;
}

export interface HistoryDropdownProps {
  id?: string;
  placeholder?: string;
  options: Option[];
  value: string;
  onChange: (value: string) => void;
  onClick: (event:React.MouseEvent) => void;
  className?: string;
  position?: 'top' | 'bottom';
  disabled?: boolean;
}

function HistoryDropdown({
  id,
  placeholder = 'Select an option',
  options,
  value,
  onChange,
  onClick,
  disabled = false,
  position = 'bottom',
  className = '',
}: HistoryDropdownProps): React.JSX.Element {
  const [isOpen, setIsOpen] = useState(false);
  const [portalStyle, setPortalStyle] = useState<React.CSSProperties>({});
  const dropdownRef = useRef<HTMLDivElement>(null);
  const headerRef = useRef<HTMLDivElement>(null);
  const listRef = useRef<HTMLUListElement>(null);

  const handleClose = () => setIsOpen(false);

  const selectedOption = useMemo(()=>options.find((opt) => opt.value === value),[options,value]);
  const hasOptions = options.length!==0;

  const updatePortalPosition = useCallback(() => {
    const target = headerRef.current ?? dropdownRef.current;
    if (!target) return;

    const rect = target.getBoundingClientRect();
    const viewportPadding = 8;
    const maxWidth = Math.min(520, window.innerWidth - viewportPadding * 2);
    const width = Math.min(Math.max(rect.width, 170), maxWidth);
    const left = Math.min(
      Math.max(rect.left, viewportPadding),
      Math.max(viewportPadding, window.innerWidth - width - viewportPadding),
    );

    const nextStyle: React.CSSProperties = {
      left,
      minWidth: rect.width,
      maxWidth,
    };

    if (position === 'top') {
      nextStyle.bottom = Math.max(
        viewportPadding,
        window.innerHeight - rect.top,
      );
    } else {
      nextStyle.top = Math.min(
        rect.bottom,
        window.innerHeight - viewportPadding,
      );
    }

    setPortalStyle(nextStyle);
  }, [position]);

  useEffect(() => {
    if (!isOpen) return;
    updatePortalPosition();
    const handleWindowChange = () => updatePortalPosition();
    window.addEventListener('resize', handleWindowChange);
    window.addEventListener('scroll', handleWindowChange, true);
    return () => {
      window.removeEventListener('resize', handleWindowChange);
      window.removeEventListener('scroll', handleWindowChange, true);
    };
  }, [isOpen, updatePortalPosition]);

  // esc로 드롭다운 닫기
  useEffect(() => {
    if (!isOpen) return;
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        // event.preventDefault();
        event.stopPropagation();
        handleClose();
      }
    };
    window.addEventListener('keydown', handleKeyDown, true); // register capturing
    return () => window.removeEventListener('keydown', handleKeyDown, true); // unregister capturing
  }, [isOpen]);

  // 아웃사이드 닫기
  useEffect(() => {
    if (!isOpen) return;
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node;
      if (
        dropdownRef.current?.contains(target) ||
        listRef.current?.contains(target)
      ) {
        return;
      }
      handleClose();
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const dropdownList = isOpen && hasOptions ? (
    <ul
      ref={listRef}
      className={`${styles.list} ${styles.portalList}`}
      style={portalStyle}
    >
      {options.map((opt) => (
        <li
          key={opt.value}
          className={`${styles.item} ${value === opt.value ? styles.selected : ''}`}
          // style={{
          //   pointerEvents:value === opt.value ?'none':'auto'
          // }}
          onClick={() => {
            onChange(opt.value);
            handleClose();
          }}
        >
          <span className={styles.placeholder}>
            {opt.label}
          </span>
        </li>
      ))}
    </ul>
  ) : null;

  return (
    <div
    ref={dropdownRef}
    className={`${styles.historyDropdown} ${className} ${disabled?styles.disabled:''}`}
    id={id}
    onClick={onClick}
    >
      <div
        ref={headerRef}
        className={styles.dropdownHeader}
        onClick={() => {
          if (!selectedOption) {
            setIsOpen(false);
            return;
          }
          if (!disabled) {
            setIsOpen(!isOpen);
          }
        }}
      >
        <span className={styles.placeholder}>
          {selectedOption ? selectedOption.label : placeholder}
        </span>
        {hasOptions && (
          <span className={`${styles.arrow} ${isOpen ? styles.open : ''}`}>
            <DropDown/>
          </span>
        )}
      </div>
      {dropdownList && createPortal(dropdownList, document.body)}
    </div>

  );
}

export default HistoryDropdown;

// <div ref={dropdownRef} className={`history-dropdown ${value ? 'filled' : 'empty'}`} id={id}>
//       <div
//         className={`dropdown-header ${value ? 'filled' : 'empty'}`}
//         onClick={() => {
//           if (!disabled) {
//             setIsOpen(!isOpen);
//           }
//         }}
//       >
//         <span className="label-text">
//           {selectedOption ? selectedOption.label : placeholder}
//         </span>
//         {hasOptions && (
//           <span className={`arrow ${isOpen ? 'open' : ''}`}>
//             <DropDown/>
//           </span>
//         )}
//       </div>
//       {isOpen && hasOptions &&(
//         <ul className={`dropdown-list position-${position}`}>
//           {options.map((opt) => (
//             <li
//               key={opt.value}
//               className={`dropdown-item ${value === opt.value ? 'selected' : ''}`}
//               // style={{
//               //   pointerEvents:value === opt.value ?'none':'auto'
//               // }}
//               onClick={() => {
//                 onChange(opt.value);
//                 handleClose();
//               }}
//             >
//               {opt.label}
//             </li>
//           ))}
//         </ul>
//       )}
//     </div>

